import { useEffect, useState, useCallback } from 'react';
import { SalesEnablementEventTypes } from '../enums/SalesEnablementEventTypes';
import { CheckoutRoutes } from '../enums/CheckoutRoutes';
import sessionStorageService from '../services/sessionStorageService';
import storageKeys from '../constants/storageKeys';
import useWidgetContext from './useWidgetContext';
const useSalesEnablementCommunication = (onSelectDealerOptions, saveFinanceFormInputPayload) => {
    const isInSalesEnablement = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window !== top || window.__CYPRESS_IS_IN_IFRAME;
    const { configuration } = useWidgetContext();
    const [sessionId, setSessionId] = useState(null);
    const [isConfirmationPreviewOpen, setIsConfirmationPreviewOpen] = useState(false);
    const [isPreviewing, setIsPreviewing] = useState(false);
    const [initializedWithStock, setInitializedWithStock] = useState(false);
    const [customizeVersion, setCustomizeVersion] = useState(0);
    const isInConfirmationPage = useCallback((location) => {
        return (location.pathname === CheckoutRoutes.CONFIRMATION && isInSalesEnablement);
    }, [isInSalesEnablement]);
    const sendIsInCustomisePage = useCallback((data) => {
        window.parent.postMessage({
            type: SalesEnablementEventTypes.IS_CUSTOMIZE_PAGE,
            payload: data,
        }, '*');
    }, []);
    const sendIsInCheckoutPage = useCallback((isInCheckoutPage) => {
        window.parent.postMessage({
            type: SalesEnablementEventTypes.IS_CHECKOUT_PAGE,
            payload: isInCheckoutPage,
        }, '*');
    }, []);
    const sendBackToStepRedirect = useCallback(() => {
        window.parent.postMessage({
            type: SalesEnablementEventTypes.BACK_TO_STEP_REDIRECT,
        }, '*');
    }, []);
    useEffect(() => {
        if (!isInSalesEnablement) {
            return;
        }
        const onMessage = (message) => {
            if (message.data.type === SalesEnablementEventTypes.RELOAD_CUSTOMIZE) {
                setCustomizeVersion(state => ++state);
            }
            if (message.data.type === SalesEnablementEventTypes.SESSION_ID) {
                setSessionId(message.data.payload);
            }
            if (message.data.type === SalesEnablementEventTypes.INITIALIZED_WITH_STOCK) {
                setInitializedWithStock(!!message.data.payload);
            }
            if (message.data.type === SalesEnablementEventTypes.FINANCE_FORM_INPUT) {
                const { payload } = message.data;
                sessionStorageService.set(storageKeys.SE_CONFIG_FINANCEFORMINPUT, 'true');
                if (payload &&
                    payload !== 'null' &&
                    payload !== 'false' &&
                    saveFinanceFormInputPayload) {
                    saveFinanceFormInputPayload(configuration.dimensions, payload);
                }
            }
            if (message.data.type === SalesEnablementEventTypes.SELECT_DEALER_OPTIONS) {
                onSelectDealerOptions && onSelectDealerOptions();
            }
            if (message.data.type === SalesEnablementEventTypes.SE_PREVIEW) {
                setIsConfirmationPreviewOpen(message.data.payload);
                setIsPreviewing(true);
            }
        };
        window.addEventListener('message', onMessage);
        window.parent.postMessage({ type: SalesEnablementEventTypes.REQUEST_SESSION_ID }, '*');
        window.parent.postMessage({ type: SalesEnablementEventTypes.WAS_INITIALIZED_WITH_STOCK }, '*');
        if (saveFinanceFormInputPayload) {
            window.parent.postMessage({ type: SalesEnablementEventTypes.REQUEST_FINANCE_FORM_INPUT }, '*');
        }
        return () => window.removeEventListener('message', onMessage);
    }, [
        configuration.dimensions,
        isInSalesEnablement,
        onSelectDealerOptions,
        saveFinanceFormInputPayload,
    ]);
    return {
        sendIsInCustomisePage,
        sendIsInCheckoutPage,
        sendBackToStepRedirect,
        setIsPreviewing,
        isInConfirmationPage,
        isPreviewing,
        isConfirmationPreviewOpen,
        isInSalesEnablement,
        customizeVersion,
        sessionId,
        initializedWithStock: isInSalesEnablement && initializedWithStock,
    };
};
export default useSalesEnablementCommunication;
//# sourceMappingURL=useSalesEnablementCommunication.js.map